import { NextRouter } from 'next/router';

import { requireMFAValidation } from '../../../utils/helper';
import { events, track } from '../../../utils/analytics';

export const nextAction = async ({
  user,
  router,
  redirectURL,
  TENANCY,
  clientId,
  mfaToken,
}: {
  user: any;
  router: NextRouter;
  clientId: string;
  redirectURL?: any;
  TENANCY?: any;
  mfaToken: string | undefined;
}) => {
  const {
    accessToken: { jwtToken: accessToken },
    idToken: { jwtToken: idToken },
    refreshToken: { token: refreshToken },
  } = user.signInUserSession;
  track({
    action: events.USER_LOGGED_IN,
    params: {
      user_id: user?.attributes?.sub,
      source: 'Cognito',
      appId: clientId,
    },
  });
  if (await requireMFAValidation(mfaToken, clientId)) {
    router.push({ pathname: '/verifycode', query: router.query });
  } else if (router.query && router.query.redirectTo) {
    const query = router.query;
    const { redirectTo } = query;
    delete query.redirectTo;
    router.push({ pathname: `/${redirectTo}`, query });
  } else {
    window.location.replace(
      `${redirectURL}${
        TENANCY === 'APS' ? '' : '#/callback'
      }?id_token=${idToken}&access_token=${accessToken}${
        TENANCY === 'APS' ? `&refresh_token=${refreshToken}` : ''
      }${
        router.query && router.query.state ? `&state=${router.query.state}` : ''
      }`
    );
  }
};
